import React from "react";
import { Box } from "@mui/material";
import { CreatePageList } from "@app/components/Layouts/PageList";
import { Add } from "@app/components/Actions";
import { CustomDataGrid } from "@app/components";
import { useNavigate } from "react-router-dom";
import { GridRowParams } from "@mui/x-data-grid";
import pathRoutes from "../../routes/pathRoutes";

import FilterTransitDose from "./components/filterTransitDose";
import { columnsTransitDoses } from "./utils/columnsTransitDoses";
import { useTransitDose } from "./utils/useTransitDose";
import { PermissionComponentGate } from "@app/utils/PermissionComponentGate";
import { RolesTypes } from "../users/utils/helpers";
import usePermission from "@app/context/PermissionContext";

const TransitDoseList = () => {
  const { filteredTransitDoses } = useTransitDose();
  const dataTransitDoses = filteredTransitDoses();
  const navigate = useNavigate();
  const { isAdmin, isSuperAdmin } = usePermission();

  const handleRowDoubleClick = (params: GridRowParams): void => {
    if (isAdmin || isSuperAdmin)
      navigate(`${pathRoutes.ADMIN_TRANSIT}/editar/${params.id}`);
  };
  return (
    <CreatePageList
      title="Listado de dosis de tránsito "
      buttonRight={
        <PermissionComponentGate
          permissions={[RolesTypes.ADMIN, RolesTypes.SUPER_ADMIN]}
        >
          <Add to={`admin/transito/nuevo`} title="Nueva dosis de tránsito" />
        </PermissionComponentGate>
      }
    >
      <FilterTransitDose />
      <Box sx={{ flex: 1, display: "flex", flexDirection: "column", mt: 1 }}>
        <CustomDataGrid
          rows={dataTransitDoses}
          columns={columnsTransitDoses}
          search={false}
          handleRowDoubleClick={handleRowDoubleClick}
        />
      </Box>
    </CreatePageList>
  );
};

export default TransitDoseList;
